export class PdfViewerDefaultProxy<CONTROLLER> {
    protected controllerInstance: CONTROLLER;

    constructor(controllerInstance?: CONTROLLER) {
        if (controllerInstance) {
            this.setController(controllerInstance);
        }
    }

    public setController(controllerInstance: CONTROLLER) {
        this.controllerInstance = controllerInstance;
    }

    public removeController() {
        this.controllerInstance = undefined;
    }

    public hasController(): boolean {
        return !! this.controllerInstance;
    }

    protected call(callback: (controller?: CONTROLLER) => any) {
        if (this.controllerInstance && callback) {
            return callback(this.controllerInstance);
        } else {
            // eslint-disable-next-line no-console
            console.warn('controllerInstance is undefined');
        }
    }
}
